var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex h-full w-full"},[_c('GChart',{staticClass:"mx-auto w-full",attrs:{"settings":{ packages: ['corechart'], },"type":"AreaChart","data":_vm.lineChartData,"options":_vm.options},on:{"ready":_vm.onChartReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }